<template>
  <div>
    <vue2-org-tree
      v-if="root && isRender"
      :data="root"
      :horizontal="true"
      :collapsable="true"
      :renderContent="renderContent"
      @onExpand="onExpand"
      @onNodeClick="onNodeClick"
    ></vue2-org-tree>
    <vbdi-process-moreinfo-banhanh
      v-if="
            isEnable &&
              selectedNodeType === PROCESS_TREE.NODE_TYPE.BANHANH_NODE
          "
      :isOpen="isOpen"
      :docId="docId"
      @closeDialog="isOpen = false"
      @closed="isEnable = false"
    />
  </div>
</template>

<script>
  import Vue from "vue";
  import Vue2OrgTree from "./vue2-tree/components/org-tree";
  import VbdiProcessMoreinfoCxlcanhan from "./vbdi-process-moreinfo-cxlcanhan";
  import VbdiProcessMoreinfoBanhanh from "./vbdi-process-moreinfo-banhanh";
  import constants from "../../../constants";
  import vbdiLuongxulyMixin from "../../../mixins/vbdi-luongxuly-mixin";

  Vue.use(Vue2OrgTree);

  export default {
    name: "vbdi-luongxuly-kyngoai",
    props: ["docId", "isConfigLD","isForBlockedRole", "isConfigQLVBTHVP"],
    mixins: [vbdiLuongxulyMixin],
    components: {VbdiProcessMoreinfoBanhanh, VbdiProcessMoreinfoCxlcanhan},

    data() {
      return {
        nodeInfo: null,
        flowInstance: null,
        isOpen: false,
        isEnable: false,
      };
    },

    watch: {
      isOpen(newValue) {
        newValue && (this.isEnable = newValue);
      },
      docId() {
        this.initLoad()
      }
    },

    computed: {
      selectedNodeType() {
        return this.selectedNode ? this.selectedNode.type : null;
      },

      blockedUserId() {
        return this.$store.getters.lockedUserDeptRole.userId
      }
    },

    created() {
      let loadDocPromise;
      if (this.isConfigLD) {
        loadDocPromise = this.loadDocForConfigLD();
      }
      else {
        loadDocPromise = this.loadDoc();
      }
      loadDocPromise
        .then(() => this.loadClonedVbIncomingDocs())
        .then(() => this.loadBanHanhDepartments())
        .then(() => this.loadDocReceivers())
        .then(() => this.convertToTreeData())
        .then(() => this.isRender = true)
        .then(() =>this.initLoad())
    },

    methods: {
      initLoad() {
        let loadDocPromise;
        if (this.isForBlockedRole) {
          loadDocPromise = this.loadDocForBlockedRole(this.blockedUserId)
        } else if (this.isConfigQLVBTHVP) {
          loadDocPromise = this.loadDocForConfigTHVP()
        }  else {
          loadDocPromise = this.loadDoc()
        }
        loadDocPromise
          .then(() => this.loadClonedVbIncomingDocs())
          .then(() => this.loadBanHanhDepartments())
          .then(() => this.loadDocReceivers())
          .then(() => this.convertToTreeData())
          .then(() => this.isRender = true)
      },

      convertToTreeData() {
        this.root = this.buildRootNode();
        this.buildTreeDataForAfterKyDuyet(this.root);
      },

      buildRootNode() {
        let editorDeptNode = this.buildNodeForEditorDept();
        let signerNode = this.buildNodeForSigner();
        if (editorDeptNode || signerNode) {
          return (editorDeptNode || signerNode);
        } else {
          return this.buildNodeForPublisherDept();
        }
      },

      buildTreeDataForAfterKyDuyet(treeNode) {
        switch (this.doc.status) {
          case constants.OUTGOING_DOC_STATUS.TU_CHOI_BAN_HANH:
            treeNode.children = [this.buildTreeDataForTuChoiBHanhNodes()];
            break;
          case constants.OUTGOING_DOC_STATUS.DABANHANH:
            treeNode.children = [this.buildTreeDataForBanHanhNodes()];
            break;
          case constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH:
            treeNode.children = [this.buildTreeDataForChoBanHanhNode()];
            break;
        }
        return treeNode;
      },

      buildNodeForPublisherDept() {
        let treeNode = {};
        treeNode.id = this.doc.publisherId;
        treeNode.expand = true;
        treeNode.type = constants.PROCESS_TREE.NODE_TYPE.PUBLISHER_DEPT_NODE;
        treeNode.doc = this.doc;
        return treeNode;
      },

      buildNodeForEditorDept() {
        if (!this.doc.deptEditorId) return null;
        let treeNode = {};
        treeNode.id = this.doc.deptEditorId;
        treeNode.expand = true;
        treeNode.type = constants.PROCESS_TREE.NODE_TYPE.EDITOR_DEPT_NODE;
        treeNode.doc = this.doc;
        return treeNode;
      },

      buildNodeForSigner() {
        if (!this.doc.signerId) return null;
        let treeNode = {};
        treeNode.id = this.doc.signerId;
        treeNode.expand = true;
        treeNode.type = constants.PROCESS_TREE.NODE_TYPE.SIGNER_NODE;
        treeNode.doc = this.doc;
        return treeNode;
      },

      renderSignerNode(h, data) {
        let doc = this.doc;
        let classes = [
          "node_handlder flex-row flex__center",
          this.user.id === doc.signerId ? "active" : ""
        ];
        let components = [];
        components.push(
          h("div", {class: "flex-col flex__center"}, [
            h("div", {class: "profileIsRead"}, [
              h("div", {class: "avatar_fake flex-row flex__center"}, [
                h("span", this.buildShortName(doc.signerName))
              ]),
              h("i", {
                class:
                  "fas fa-check-circle font-size__medium icon-read border-radius__50"
              })
            ]),
            h("div", {class: "info"}, [
              h("div", {class: "name no_wrap"}, doc.signerName),
              doc.signerPosName ? h(
                "div",
                {class: "more-info font-size__small"},
                doc.signerPosName
              ) : null
            ])
          ])
        );
        return h("div", {class: classes.join(" ")}, components);
      },

      renderEditorDeptNode(h, data) {
        return this.renderDeptNode_(h, data, this.doc.publisherName);
      },

      renderPublisherDeptNode(h, data) {
        return this.renderDeptNode_(h, data, this.doc.publisherName);
      },

      renderDeptNode_(h, data, deptName) {
        let classes = [
          "node_handlder flex-row flex__center",
        ];
        let components = [];
        components.push(
          h("div", {class: "flex-col flex__center"}, [
            h("div", {class: "avatar_fake flex-row flex__center"}, [
              h("span", this.buildShortName(deptName))
            ]),
            h("div", {class: "info"}, [
              h("div", {class: "name no_wrap"}, deptName)
            ])
          ])
        );

        return h("div", {class: classes.join(" ")}, components);
      },

      renderContent(h, data) {
        switch (data.type) {
          case constants.PROCESS_TREE.NODE_TYPE.BANHANH_NODE:
            return this.renderBanHanhNode(h, data);
          case constants.PROCESS_TREE.NODE_TYPE.CHOBANHANH_NODE:
            return this.renderChoBanHanhNode(h, data);
          case constants.PROCESS_TREE.NODE_TYPE.DONVIBANHANH_NODE:
            return this.renderDonViBanHanhNode(h, data);
          case constants.PROCESS_TREE.NODE_TYPE.DONVIBANHANHNGOAI_NODE:
            return this.renderDonViBanHanhNgoaiNode(h, data);
          case constants.PROCESS_TREE.NODE_TYPE.TUCHOITIEPNHAN_NODE:
          case constants.PROCESS_TREE.NODE_TYPE.TUCHOI_NODE:
            return this.renderTuChoiNode(h, data);
          case constants.PROCESS_TREE.NODE_TYPE.PUBLISHER_DEPT_NODE:
            return this.renderPublisherDeptNode(h, data);
          case constants.PROCESS_TREE.NODE_TYPE.EDITOR_DEPT_NODE:
            return this.renderEditorDeptNode(h, data);
          case constants.PROCESS_TREE.NODE_TYPE.SIGNER_NODE:
            return this.renderSignerNode(h, data);
        }
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/doc-out/components/vbdi-luongxuly-kyngoai.vue